import { showAlertPopup } from "../../redux/actions/AlertErrorMessage/alertErrorMessage.action";
import Login from "./Login";
import {connect} from "react-redux";

const mapStateToProps = null;

const mapDispatchToProps = (dispatch)=>{
    return {
        showAlertPopup: (alertHeader,alertmessage) => {
            return dispatch(showAlertPopup(alertHeader,alertmessage))
          },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);


